import { useState, useEffect, useRef } from "react";
import PlayerCard from "../PlayerCard/PlayerCard";
import styles from "./Lobby.module.css";
import placeholderLogo from '../../assets/logo-game.png';

import popSound from "../../assets/audios/pop.mp3";
import soundTrackRanking from "../../assets/audios/RankingSound.mp3";
import CloseCaptionButton from "../Buttons/CloseCaptionButton";
import { SUBTITLE_RESTRICTION } from "../../utils/constants";
import { formatTime } from "../../utils/formatUtils";
import InGameHeader from "../in-game/InGameHeader";


const loadingTexts = ["DIBUJANDO MONTAÑAS", "PINTANDO CIELO", "CREANDO MAGIA", "CARGANDO JUGADORES"];

const Lobby = ({ game, user, socket }) => {
  const [timer, setTimer] = useState(game?.timeToStart || 60);
  const audioRef = useRef(null); // Referencia para el audio

  const [loadingText, setLoadingText] = useState(loadingTexts[0]);

  const playSound = () => {
    const sound = new Audio(popSound);
    sound.play();
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "isMuted" && audioRef.current) {
        audioRef.current.muted = event.newValue === "true";
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);


  useEffect(() => {
    let textIndex = 0;
    const textInterval = setInterval(() => {
      textIndex = (textIndex + 1) % loadingTexts.length;
      setLoadingText(loadingTexts[textIndex]);
    }, 3000);
    if (game.gameName.toLowerCase() === SUBTITLE_RESTRICTION.toLowerCase()) {
      setIsCCActive(localStorage.getItem("subtitles") === "true");
    }
    return () => clearInterval(textInterval);
  }, [game.gameName]);

  useEffect(() => {
    const updateTimer = ({ gameId, timeToStart }) => {
      if (gameId === game?.id) {
        setTimer(timeToStart);
      }
    };

    socket.on("countdown_updated", updateTimer);

    return () => {
      socket.off("countdown_updated", updateTimer);
    };
  }, [socket, game?.id]);

  const handleReady = () => {
    playSound();
    socket.emit("player_ready", { gameId: game.id, playerId: user });
  };

  const [isCCActive, setIsCCActive] = useState(false);
  const toggleCC = () => {
    const newValue = localStorage.getItem("subtitles") === "true" ? "false" : "true";
    localStorage.setItem("subtitles", newValue);
    setIsCCActive(newValue === "true");
  };

  const playerIsReady = game.players.some((p) => p.id === user && p.status === "ready");

  return (
    <div className={styles.lobby}>
      <audio ref={audioRef} autoPlay controls loop style={{
        position: 'absolute',
        zIndex: 100,
        opacity: 0
      }}>
        <source src={soundTrackRanking} type="audio/mp3" />
      </audio>
      {/* Player List */}
      <div className={styles.lobbyContainer}>
        {/* Header */}
        <InGameHeader
          brandLogo={game.companyLogo ? encodeURI(game.companyLogo) : placeholderLogo}
          title={game.gameName}
          subtitle={game.moduleName}
        />

        <div className={styles.contPlayer}>
          {Array.from({ length: Math.max(game.playersToStart, game.players.length) }).map((_, index) => {
            const player = game.players[index];
            return player ? (
              <PlayerCard key={player.id} player={player} isRanking={false} />
            ) : (
              <PlayerCard key={`empty-${index}`} player={null} isRanking={false} disabled />
            );
          })}

        </div>

        {/* counter player */}
        <div className={styles.playersCount}>
          <label>{game.players.length}/{game.playersToStart}</label>
        </div>

        <div className={styles.generalContainerBorder}>
          <div className={styles.generalContainer}>
            <label className={styles.textTimer}>El juego comienza en</label>
            {/* Timer */}
            <div className={styles.timer}>{formatTime(timer)}</div>

            <button className={styles.borderPrincipalBtn}
              onClick={handleReady}
              disabled={playerIsReady}>
              <div className={styles.principalBtn}>
                Estoy listo
              </div>
            </button>


          </div>
        </div>
      </div>

      {(game.gameName.toLowerCase() === SUBTITLE_RESTRICTION.toLowerCase())
        && <CloseCaptionButton isActive={isCCActive} onClick={toggleCC} />}
    </div>
  );
};

export default Lobby;